import React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import dragon from "./../../images/dragon847.png"
import osiris from "./../../images/osiris847.png"
import tiberia from "./../../images/tiberia847.jpg"
import timetravel from "./../../images/timetravel847.jpg"
import pirates from './../../images/pirates_plague847.jpg'
import manor from './../../images/manor847.jpg'
import laserbots from './../../images/laserbots847.png'
import runaway from './../../images/runaway_train847.jpg'
import m_dragon from "./../../images/mobile_game_tiles/m_dragontower.jpg"
import m_osiris from "./../../images/mobile_game_tiles/m_depthofosiris.jpg"
import m_tiberia from "./../../images/mobile_game_tiles/m_spacestation.jpg"
import m_timetravel from "./../../images/mobile_game_tiles/m_timetravel.jpg"
import m_pirates from './../../images/mobile_game_tiles/m_piratesplague.jpg'
import m_manor from './../../images/mobile_game_tiles/m_manor.jpg'
import m_laserbots from './../../images/mobile_game_tiles/m_laserbots.jpg'
import m_runaway from './../../images/mobile_game_tiles/m_runaway.jpg'
import badge from "./../../images/2-6_Room_Badge.svg"
import {Box, Button, Paper, Typography} from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2';
import {Link} from 'react-router-dom'
import TimerIcon from '@mui/icons-material/Timer';
import SpeedIcon from '@mui/icons-material/Speed';
export const GameTiles = () => {
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    };
    var items = [
        /* opaque header
             <Paper style={{width:"100%", position:"absolute",  top:"0%", opacity:".8", backgroundColor:"black"}} >
                    <Typography color="white" variant = "h5" maxWidth="100%" textAlign={"center"} sx={{wordWrap:"break-word"}} fontFamily="Copperplate" >
                        {item.txt}
                    </Typography>
                    </Paper>
            */
        {
            src: runaway,
            m_src: m_runaway,
            txt: "Runaway Train",
            link: "/RunawayTrain",
            desc: `Dr. Steem built automatons to take over the town under the guise 
            of “progress”. When you poked around too much, he framed you and soiled your good name.
            The townspeople finally discovered the truth and captured Dr. Steem, 
            but it was too late. His automatons sprung him loose from jail, and 
            now he’s out for revenge. He loaded a train with dynamite, and it’s 
            headed for town! It’s time to pony up and save your beloved town.`,
            time: "60",
            difficulty: "Expert"
        },
        {
            src: timetravel,
            m_src: m_timetravel,
            txt: "Time Travel Paradox",
            link: "/TimeTravel",
            desc: `Betrayed by your trusted colleague, you launch your team into a 
             voyage across the ages in order to stop an evil mastermind. Don’t get distracted by 
             the beauty of prehistoria or the ravaged dystopian city-scape… time is of the essence!
              The only way to control time is to understand it! Can you?`,
            time: "45",
            difficulty: "Expert"
        },
        {
            src: manor,
            m_src: m_manor,
            txt: "Manor of Escape",
            link: "/Manor",
            desc: `Do you dare to enter the mad scientist's manor? Strange screams are coming from Count
             Malum's estate in the night. Rumors have spread that the Count has opened a portal to an 
             alternate dimension. Some of the locals are missing and the townspeople have grown uneasy. 
             Your team is called to investigate and put an end to his evil experiments.`,
            time: "45",
            difficulty: "Expert"
        },
        {
            src: pirates,
            m_src: m_pirates,
            txt: "Pirate's Plague",
            link: "/Pirates",
            desc: `Cursed and transformed into fish people, your pirate crew must race to a remote island
             while fending off attacking pirates, solve puzzles in an ancient temple, and break the curse
             before you lose your human form forever!`,
            time: "45",
            difficulty: "Advanced"
        },
        {
            src: dragon,
            m_src: m_dragon,
            txt: "Dragon Tower",
            link: "/Dragon",
            desc: `Imprisoned with the skeletal remains of the evil alchemist's earlier victims,
            you and your traveler friends regret your recent decision to stay at the local Inn!
            Accused of a crime you didn’t commit, you must use the Alchemist's magic against him
            and find a way to escape your prison before you and your friends meet a fiery fate.`,
            time: "45",
            difficulty: "Intermediate"
        },
        {
            src: osiris,
            m_src: m_osiris,
            txt: "Depths of Osiris",
            link: "/Osiris",
            desc:  `You and your team of treasure hunters have a once-in-a-lifetime opportunity to
             dive deep into the waters of the Atlantic in search of never-before-seen riches. Escape
              the deep sea platform and solve the mysteries of the Temple, but don't stop looking 
              over your shoulder in these shark-infested waters!`,
            time: "45",
            difficulty: "Intermediate"
        },
        
        {
            src: tiberia,
            m_src: m_tiberia,
            txt: "Space Station Tiberia",
            link: "/Tiberia",
            desc: `You and your team of astronauts have the worst luck! A radiation storm knocked 
            out vital systems just when a meteor is hurtling towards Earth. You have to get Space 
            Station Tiberia up and running, and fix the anti-meteor laser array before it's too late.
             The view of earth from low orbit is breathtaking, but this is no time to stargaze! 
             It's time to save the world!`,
            time: "45",
            difficulty: "Beginner"
        },
        {
            
            src: laserbots,
            m_src: m_laserbots,
            txt: "Laserbots",
            link: "/Laserbots",
            desc: `Force shield and laser sword in hand, you and your landing team must defend yourselves
             against a massive droid attack. Keep your wits about you as you use their own technology 
             to destroy them one by one. But, their code is not static! They learn to counter your tactics.
              Can this be the singularity we've all been dreading?`,
            time: "20",
            difficulty: "Beginner"
        },
      ]
  return (
    <>
        {
            items.map( (item) => (<Grid container padding = {5} marginX={0} alignItems={"stretch"} justifyContent={"center"}>
                <Grid item md = {12} lg ={6}>
                    <Box position="relative" justifyContent={"center"} >
                    <a href={item.link}>
                        <Box display={{xs:"none",sm:"flex"}}>
                            <img src={item.src} alt = {item.txt} style = {{width: "100%", height: "100%", display: "block"}}/>
                        </Box>
                        <Box display={{xs:"flex",sm:"none"}}>
                            <img src={item.m_src} alt = {item.txt} style = {{width: "100%", height: "100%", display: "block"}}/>
                        </Box>
                        </a>
                    <img src={badge} style={{ position:"absolute", top:"5%", right:"5%", width:"15%"}} alt = "Badge"/>
                    </Box>
                    <Box display={{xs:"flex", sm:"none"}}>
                    <Accordion expanded={expanded === `${item.txt}`} onChange={handleChange(`${item.txt}`)}
                    style={{ backgroundColor:"black", color:"white"}}>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon fontSize='large' color="primary"/>}
                        aria-controls={item.txt}
                        id={item.txt}
                        >
                        Description 
                        </AccordionSummary>
                        <AccordionDetails>
                        <Typography fontFamily={"Sans-Serif"}>
                            {item.desc}
                        </Typography>
                        </AccordionDetails>
                    </Accordion>
                    </Box>
                </Grid>
                <Grid  item display={{xs:"none" , sm: "flex"}} md = {12} lg={4} color="white" >
                    <Paper style={{backgroundColor:"black", display:"flex", flexDirection:"column", justifyContent:"space-between"}}>
                    <Typography variant = "h5" color="white" fontFamily={"Sans-Serif"} paddingY ={5}>
                        {item.desc} 
                    </Typography>
                    <Typography variant = "caption1" color="white" fontFamily={"Copperplate"}>
                    <TimerIcon/>{item.time} minutes &emsp;&emsp;
                        <SpeedIcon/> {item.difficulty} &emsp;
                        <Link reloadDocument to ={item.link}>
                        <Button variant="contained" style={{whiteSpace:"nowrap", borderRadius:"20px"}}>
                            <Typography variant = "caption1" fontFamily={"Copperplate"}>
                            Book Now
                            </Typography>
                        </Button>
                    </Link>
                    </Typography>
                    </Paper>   
                </Grid>
                </Grid>))
        }  
    </>     
  )
}